import { environment } from '@env/environment';
import { HttpLinkProps } from '@typings';

export const createRequestLink = ({ httpLink }: HttpLinkProps) => {
  return httpLink.create({
    uri: environment.baseUrl,
  });
};
